import { getPastOrdersApi } from "../../../api/get/getPastOrdersApi";
import { createCustomer } from "../../../api/post/createCustomerApi";
import { searchCustomer } from "../../../api/post/searchCustomerApi";
import { clearCart } from "../restaurants/restaurantSlice";
import { emptyCartAsync } from "../restaurants/restaurantThunks";
import { setCreatedCustomer, setPastOrders, setSearchedCustomer, setActiveOrders } from "./customerSlice";
import { updateCustomer } from "../../../api/post/updateCustomerApi";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const createCustomerAsync = (customerData) => async (dispatch) => {
  try {
    const response = await createCustomer(customerData);
    // Extract just the data object from the API response
    const customerDataOnly = response.data || response;
    dispatch(setCreatedCustomer(customerDataOnly));
    return { success: true, data: customerDataOnly };
  } catch (error) {
    console.error("Customer creation failed:", error);
    return { 
      success: false, 
      error: error.response?.data || { message: 'Failed to create customer' } 
    };
  }
};

export const searchCustomerAsync = (mobileCountryCode, mobileNo, serviceType) => async (dispatch) => {
  try {
    const customerData = await searchCustomer(mobileCountryCode, mobileNo);
    dispatch(setSearchedCustomer({...customerData, service_type: serviceType}));  // Store search results in Redux state
    dispatch(clearCart());
    dispatch(emptyCartAsync(customerData?.id));
  } catch (error) {
    console.error("Customer search failed:", error);
  }
};

export const customerPastOrdersAsync = (customerId) => async (dispatch) => {
  try {
    const pastOrders = await getPastOrdersApi(customerId);
    // Dispatch all orders as past orders
    dispatch(setPastOrders(pastOrders.data));
    // The setActiveOrders reducer will handle the filtering and field selection
    dispatch(setActiveOrders(pastOrders.data));
    
  } catch (error) {
    console.error("Past Order Search failed:", error);
  }
};

export const updateCustomerAsync = createAsyncThunk(
  "customer/updateCustomer",
  async (customerData, { dispatch, rejectWithValue }) => {
    try {
      const response = await updateCustomer(customerData);
      
      if (response.success) {
        // Re-fetch customer data to update the state with latest info
        await dispatch(searchCustomerAsync("+965", customerData.mobile_no));
        return response.data;
      }
      
      return rejectWithValue(response.message || "Failed to update customer");
    } catch (error) {
      return rejectWithValue(error.message || "An error occurred while updating customer");
    }
  }
);